module.exports = __webpack_public_path__ + "img/consult.6a192e11.png";